import dayjs from 'dayjs';
import { CookieStorage } from 'cookie-storage';
import { IS_LOCALHOST } from '@/config/constants';

export const _storageFactory = (storage) => {
  return {
    setItem(key, value){
      return storage.setItem(key, encodeURIComponent(value), {
        expires: (() => {
          let toBeConvertedToUTC = dayjs() //;.add(dayjs().utcOffset(),'minutes') // Strängen ska vara i UTC-format, så först läggs 2 h till, som sedan autoamtsikt tas bort när UTCString körs internt av CookieStorage

          return toBeConvertedToUTC.add(30,'minutes').toDate();
        })()
      })
    },
    getItem(key){
      if(storage.getItem(key))
        return decodeURIComponent(storage.getItem(key));
    },
    removeItem(key){
      return storage.removeItem(key);
    }
  }
}

/**
 * Sparar i en cookie
 */
export const cookieStorage = _storageFactory(new CookieStorage({
  path:'/',
  domain:location.hostname,
  secure: !IS_LOCALHOST
}))

/**
 * Sparar i sessionStorage
 */
export const sessionStorage = _storageFactory(window.sessionStorage)

/**
 * Hämta storage. Använder cookiestorage som default.
 */
export const storageFactory = (useCookie = true) => {
  return useCookie ? cookieStorage : sessionStorage;
};

